import { render, staticRenderFns } from "./DescriptionOfPlans.vue?vue&type=template&id=5dd3639a&scoped=true&"
import script from "./DescriptionOfPlans.vue?vue&type=script&lang=ts&"
export * from "./DescriptionOfPlans.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5dd3639a",
  null
  
)

export default component.exports